<script>
  import { Router, Route } from "svelte-routing"
  import Usuarios from "./pages/Usuarios.svelte"
  import UsuarioAgregar from "./pages/UsuarioAgregar.svelte"
  import Claves from "./pages/Claves.svelte"
  import Clave from "./pages/Clave.svelte"
  import ReporteConsultas from "./pages/ReporteConsultas.svelte"
  import Administrador from "./pages/Administrador.svelte"
  import Login from "./pages/Login.svelte"
  import Acciones from "./pages/Acciones.svelte"
  import Clientes from "./pages/Clientes.svelte"
  import ClienteAgregar from "./pages/ClienteAgregar.svelte"
  import Notificaciones from "./pages/Notificaciones.svelte"
  import ReporteDiario from "./pages/ReporteDiario.svelte"
  import UsuariosCargar from "./pages/UsuariosCargar.svelte"
  import ModificacionesFuturas from "./pages/ModificacionesFuturas.svelte"
  import IpsBloqueadas from "./pages/IpsBloqueadas.svelte"
</script>

<Router>
  <Route path="/">
    <Login />
  </Route>
  <Route path="/clientes">
    <Clientes />
  </Route>
  <Route path="/clientes/agregar">
    <ClienteAgregar />
  </Route>
  <Route path="/usuarios">
    <Usuarios />
  </Route>
  <Route path="/usuarios/agregar">
    <UsuarioAgregar />
  </Route>
  <Route path="/usuarios/cargar">
    <UsuariosCargar />
  </Route>
  <Route path="/usuarios/claves">
    <Claves />
  </Route>
  <Route path="/usuarios/claves/:id" let:params>
    <Clave id={params.id} />
  </Route>
  <Route path="/reporte_consultas">
    <ReporteConsultas />
  </Route>
  <Route path="/reporte_diario">
    <ReporteDiario />
  </Route>
  <Route path="/administrador">
    <Administrador />
  </Route>
  <Route path="/acciones">
    <Acciones />
  </Route>
  <Route path="/notificaciones">
    <Notificaciones />
  </Route>
  <Route path="/modificaciones_futuras">
    <ModificacionesFuturas />
  </Route>
  <Route path="/ips_bloqueadas">
    <IpsBloqueadas />
  </Route>
</Router>
